import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import UpcomingEventsSection from "./components/UpcomingEventsSection";
import BannerCarousel from "./components/BannerCarousel";
import AboutSection from "./components/AboutSection";
import GallerySection from "./components/GallerySection";
import CommunitySection from "./components/CommunitySection";
import TestimonialSection from "./components/TestimonialSection";
import JoinSection from "./components/JoinSection";
import CTAFooterSection from "./components/CTAFooterSection";
import ColonialDivider from "./components/ColonialDivider";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ColonialDivider />
      <UpcomingEventsSection />
      <ColonialDivider />
      <AboutSection />
      <ColonialDivider />
      <BannerCarousel />
      <ColonialDivider />
      <GallerySection />
      <ColonialDivider />
      <CommunitySection />
      <ColonialDivider />
      <TestimonialSection />
      <ColonialDivider />
      <JoinSection />
      <CTAFooterSection />
    </div>
  );
}